<template>
  <span>
    <span v-if="value != null">
      <a :href="url" target="_blank" v-html="value.ticketNumber" />
      por
      <code>{{ value.by }}</code>
      em
      {{ value.at | moment('DD/MMM/YYYY') }}
    </span>
    <span v-else>─</span>
  </span>
</template>

<script>
export default {
  props: {
    value: {}
  },
  computed: {
    url() {
      if (this.value == null) return null
      return (
        `https://oderon.zendesk.com/agent/tickets/` + this.value.ticketNumber
      )
    }
  }
}
</script>

<style></style>
